import { render } from "./CardComponent.vue?vue&type=template&id=274e2dd0&scoped=true&ts=true"
import script from "./CardComponent.vue?vue&type=script&lang=ts"
export * from "./CardComponent.vue?vue&type=script&lang=ts"

import "./CardComponent.vue?vue&type=style&index=0&id=274e2dd0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274e2dd0"]])

export default __exports__